// Copyright 2025, University of Maryland, All Rights Reserved
//
// Node auto-discovery using Vite's import.meta.glob.
//
// This file automatically discovers and imports all register.ts files
// in the nodes directory tree. No manual maintenance required -
// just add a register.ts file and it will be detected at build time.

// Eagerly import all register.ts files - this executes them at module load
// which triggers the registerNode() calls in each file
const registerModules = import.meta.glob('./**/register.ts', { eager: true })

// Extract registered node paths for debugging/introspection
export const DISCOVERED_NODES = Object.keys(registerModules).map((path) =>
  // Convert path like './datasource/s3/register.ts' to 'datasource/s3'
  path.replace(/^\.\//, '').replace(/\/register\.ts$/, '')
)

// Log discovery in development
if (import.meta.env.DEV) {
  console.debug(`[nodes] Discovered ${DISCOVERED_NODES.length} nodes:`, DISCOVERED_NODES)
}
